<template>
	<div class="row">
		<div class="col-xs-12 no-print print-visualizacao__btn-group">
			<div class="btn-group" role="group">
				<button
					type="button"
					class="btn"
					:class="layoutAtual === 1 ? 'btn-primary' : 'btn-default'"
					@click="alterarLayoutAtual(1)"
				>
					LAYOUT 1
				</button>
				<button
					type="button"
					class="btn"
					:class="layoutAtual === 2 ? 'btn-primary' : 'btn-default'"
					@click="alterarLayoutAtual(2)"
				>
					LAYOUT 2
				</button>
			</div>
		</div>

		<print-layout-1 v-if="layoutAtual === 1" :relatorio="relatorio" />
		<print-layout-2 v-else :relatorio="relatorio" />
	</div>
</template>

<script>
import PrintLayout1 from './print-layout-1.vue'
import PrintLayout2 from './print-layout-2.vue'

export default {
	name: 'RelatorioPrevencaoPrintVisualizar',

	components: {
		PrintLayout1,
		PrintLayout2
	},

	props: {
		id: {
			type: [String, Number],
			required: false,
			default: '0'
		}
	},

	data() {
		return {
			layoutAtual: 0,
			relatorio: {}
		}
	},

	mounted() {
		// Esse trecho de código foi adicionado para usar o segundo layout de impressão como padrão para a PF
		this.buscarRelatorio()
	},

	methods: {
		buscarRelatorio() {
			window.bus.$emit('load-in', {text: this._traducao('global', 'carregandoDados')})
			this._httpGet(`/Relatorio_prevencao/get_relatorio_prevencao/${this.id}`, (retorno) => {
				if (retorno._request && retorno._status) {
					this.relatorio = retorno.relatorio_prevencao
					this.relatorio.data = this._SQLDateToDateTime(this.relatorio.data, window.$sessao.getDateFormat() + ' HH:MM:SS')
					this.listaAnexos()
					window.setTimeout(() => {
						if (this._idCliente == 33) 
						{
						this.layoutAtual = 2
						}
						else
						{
							this.layoutAtual = 1
						}
						window.bus.$emit('load-out')
					}, 3000)
				}
			})
		},

		alterarLayoutAtual(layoutAtual) {
			if (layoutAtual === 2) {
				this.layoutAtual = 2
			} else {
				this.layoutAtual = 1
			}
		},

		listaAnexos() {
			this._axios('Relatorio_prevencao_anexo/listar/' + this.id, 'get', {
				callback: (resposta) => {
					this.relatorio.anexos = resposta.lista
				}
			})
		}
	}
}
</script>

<style scoped>
.print-visualizacao__btn-group {
	margin-bottom: 10px;
}
</style>